import Image from "next/image"

import { screenTexts } from "../localization/screen"

export function Empty() {
  return (
    <>
      <h2 className="text-sm text-white/75 ls:hidden">{screenTexts.groups.today}</h2>
      <div
        role="status"
        className="flex flex-col items-center gap-3 text-center my-24 md:my-0"
      >
        <Image
          src="/img/search/rayo-empty.png"
          alt=""
          width={140}
          height={140}
          className="size-[140px] object-contain"
        />
        <p className="text-sm text-white/50">{screenTexts.emptyTitle}</p>
      </div>
    </>
  )
}
